import { render, staticRenderFns } from "./EditCustomer .vue?vue&type=template&id=e4e3ad9a&scoped=true"
import script from "./EditCustomer .vue?vue&type=script&lang=ts"
export * from "./EditCustomer .vue?vue&type=script&lang=ts"
import style0 from "./EditCustomer .vue?vue&type=style&index=0&id=e4e3ad9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e3ad9a",
  null
  
)

export default component.exports
import {QPage,QHeader,QImg,QToolbar,QBtn,QSpace,QSeparator,QCard,QCardSection,QCardActions,QTabs,QTab,QTabPanels,QTabPanel,QForm,QInput,QSelect,QItem,QRadio,QIcon,QPopupProxy,QDate,QList,QDialog,QUploader,QStepperNavigation,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QHeader,QImg,QToolbar,QBtn,QSpace,QSeparator,QCard,QCardSection,QCardActions,QTabs,QTab,QTabPanels,QTabPanel,QForm,QInput,QSelect,QItem,QRadio,QIcon,QPopupProxy,QDate,QList,QDialog,QUploader,QStepperNavigation})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
